var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import FadeIn from '../../../../components/Animation/FadeIn';
import Button from '../../../../components/Button';
import { useWizard } from '../../../../hooks/useWizard';
import Heading from '../../../../components/Typography/Heading';
import Paragraph from '../../../../components/Typography/Paragraph';
import FormRow from '../../../../components/Form/Row';
import TextInput from '../../../../components/Fields/TextInput';
import { Fields } from '../../../../utils/Fields';
import { useOutletContext } from 'react-router-dom';
import { useValidation } from '../../../../hooks/useValidation';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Info } from '../../../../components/CustomIcon';
import { usePlaceholder } from '../../../../hooks/usePlaceholder';
var ProfessionalContact = function () {
    var values = useOutletContext().values;
    var setValuesAndGoToNextStep = useWizard().setValuesAndGoToNextStep;
    var _a = useValidation(), emailRequired = _a.emailRequired, phoneOptional = _a.phoneOptional;
    var placeholders = usePlaceholder();
    var schema = yup.object().shape({
        display_email: emailRequired,
        phone: phoneOptional,
    });
    var _b = useForm({
        resolver: yupResolver(schema),
        defaultValues: values,
    }), handleSubmit = _b.handleSubmit, control = _b.control;
    var onSubmit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            setValuesAndGoToNextStep(data);
            return [2 /*return*/];
        });
    }); };
    return (<FadeIn>
      <div className="flex flex-col gap-10 py-10">
        <div>
          <Heading level={1} type="h4">
            Comment peut-on vous contacter&nbsp;?
          </Heading>
          <Paragraph size="sm" className="pt-2 text-gray-700">
            Indiquez les coordonnées que vous souhaitez afficher sur votre profil et profitez de
            nouvelles opportunités&nbsp;!
          </Paragraph>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col gap-6">
            <FormRow>
              <TextInput label="Email" type={Fields.EMAIL} name="display_email" placeholder={placeholders.email} control={control} required/>
            </FormRow>
            <FormRow>
              <TextInput label="Téléphone" type={Fields.PHONE} name="phone" placeholder={placeholders.phone} control={control}/>
            </FormRow>
            <div className="flex w-full items-center rounded-lg bg-gray-200 p-4">
              <div className="mr-4 flex h-14 w-14 flex-none items-center justify-center rounded-full bg-brand-01">
                <Info size={32} className="fill-white"/>
              </div>
              <Paragraph size="xs" className="text-gray-700">
                Pour respecter votre vie privée, seules les personnes disposant d’un compte pourront
                accéder à vos coordonnées.
              </Paragraph>
            </div>
            <Button submit className="sm:self-end">
              Continuer
            </Button>
          </div>
        </form>
      </div>
    </FadeIn>);
};
export default ProfessionalContact;
